import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Seo } from "../components/site/Seo";
import { LEGAL_PAGES } from "../data/legal";
import { COOKIE_KEY } from "../components/site/SiteLayout";
import NotFound from "./NotFound";

const CookieReset = () => {
  const [done, setDone] = useState(false);
  return (
    <div className="mt-6 flex items-center gap-4">
      <button type="button" className="btn-secondary h-11 text-sm" onClick={() => { localStorage.removeItem(COOKIE_KEY); setDone(true); }} data-testid="cookie-reset-button">Reset cookie notice choice</button>
      {done && <span className="text-sm text-slate-500" data-testid="cookie-reset-confirmation">Your choice has been reset. The notice will appear on your next visit.</span>}
    </div>
  );
};

export default function Legal() {
  const key = useLocation().pathname.slice(1);
  const page = LEGAL_PAGES[key];
  if (!page) return <NotFound />;
  return (
    <>
      <Seo title={page.title} description={page.description} path={`/${key}`} />
      <section className="border-b border-slate-200 bg-[#F4F6F8]">
        <div className="container-x max-w-4xl py-16 lg:py-20">
          <p className="eyebrow">Legal</p>
          <h1 className="h-display mt-6">{page.title}</h1>
          <div className="mt-8 flex gap-3 rounded-md border border-amber-300 bg-amber-50 p-5 text-sm leading-relaxed text-amber-900" data-testid="legal-review-banner">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> {page.reviewNote}
          </div>
        </div>
      </section>
      <section className="bg-white py-16">
        <div className="container-x max-w-3xl">
          {page.sections.map((s) => (
            <div key={s.h} className="mb-12">
              <h2 className="font-display text-xl font-semibold text-[#0B1220]">{s.h}</h2>
              {s.p.map((p) => <p key={p.slice(0, 30)} className="mt-4 leading-relaxed text-slate-600">{p}</p>)}
            </div>
          ))}
          {key === "cookie-policy" && <CookieReset />}
        </div>
      </section>
    </>
  );
}
